import { Inject, Injectable, forwardRef} from '@angular/core';
import { Http, Response } from '@angular/http';

import  { Observable } from 'rxjs/Observable';

import { HttpClient } from './http-client.service';

import { SecurityGroup } from '../../entities/security-group';

import { Settings } from '../../settings';

import { DateConverter } from '../../utility/date-converter';

import { ODataBuilder } from '../../utility/odata/odata-builder';
import { ODataComparer } from '../../utility/odata/odata-comparer';

import { CachedCallService } from './cached-call.service';

@Injectable()
export class SecurityGroupService {

  private static readonly securityGroupBaseUrl:string = `${Settings.apiUrl}/v1/SecurityGroups`;

  protected cachedCallService:CachedCallService = new CachedCallService();

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

  getSecurityGroups(): Promise<SecurityGroup[]> {

    let oDataBuilder: ODataBuilder = new ODataBuilder(SecurityGroupService.securityGroupBaseUrl);

    oDataBuilder
      .orderBy("Name");

    let securityGroupUrl: string = oDataBuilder.toString();

    return this.http.get(securityGroupUrl)
      .toPromise()
      .then(response => response.json().value);

  }
} 



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/security-group.service.ts